<template>
    <div>
        <div class="my-2">
            <span class="btn-small btn-primary btn" @click="editMode=true">{{ stateHumanReadable }}</span>
        </div>
        <div v-if="editMode">
            <template v-for="state in this.states">
                <button @click="setState(state.name)" class="mr-2 btn-small btn btn-secondary">{{ state.human_readable }}</button>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'invoice',
            'initialStateHumanReadable',
            'states',
        ],
        data: function() {
            return {
                editMode: false,
                stateHumanReadable: this.initialStateHumanReadable,
            }
        },
        methods: {
            setState: function(state) {
                this.saveState(state)
            },
            saveState: function(state) {
                this.$http['put']('/invoices/' + this.invoice.id, {invoice: {state: state}}).then(response => {
                    console.log(response)
                    this.stateHumanReadable = response.body.state_human_readable
                    this.editMode = false
                }, response => {
                    console.log(response)
                })
            },
        },
    }
</script>